import { StatusManutencaoEnum } from "core/features/manutencao/typings";
import colors from "core/resources/theme/colors";
import { MdCheck } from "react-icons/md";
import { IoAlertSharp } from "react-icons/io5";
import { BsClockHistory } from "react-icons/bs";

export function getColorStatus(
  statusManutencaoId: StatusManutencaoEnum | undefined
) {
  switch (statusManutencaoId) {
    case StatusManutencaoEnum.Concluida:
      return colors.green100;
    case StatusManutencaoEnum.NaoRealizada:
      return colors.red100;

    default:
      return colors.orange10;
  }
}

export function getColorBorderIconStatus(
  statusManutencaoId: StatusManutencaoEnum | undefined
) {
  switch (statusManutencaoId) {
    case StatusManutencaoEnum.Concluida:
      return colors.green;
    case StatusManutencaoEnum.NaoRealizada:
      return colors.red;

    default:
      return colors.orange;
  }
}

export function getBackgroundColorStatus(
  statusManutencaoId: StatusManutencaoEnum | undefined
) {
  switch (statusManutencaoId) {
    case StatusManutencaoEnum.Concluida:
      return colors.green;
    case StatusManutencaoEnum.NaoRealizada:
      return colors.red;
    default:
      return "white";
  }
}

export function getIconStatus(
  statusManutencaoId: StatusManutencaoEnum | undefined
) {
  switch (statusManutencaoId) {
    case StatusManutencaoEnum.Concluida:
      return <MdCheck size={25} color={colors.green} />;
    case StatusManutencaoEnum.NaoRealizada:
      return <IoAlertSharp size={25} color={colors.red} />;

    default:
      return <BsClockHistory size={25} color={colors.orange} />;
  }
}
